"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designLanguage = require("@doordash/design-language");

var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));

var _styles = require("./styles");

var _InputWrapper = _interopRequireDefault(require("./InputWrapper"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

var _utilities = require("@doordash/utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX_ID = 'FieldWrapper';

var FieldWrapper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FieldWrapper, _React$PureComponent);

  var _super = _createSuper(FieldWrapper);

  function FieldWrapper() {
    var _this;

    _classCallCheck(this, FieldWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (onClick) {
      _this.fieldContent.focus();

      if (onClick) {
        onClick();
      }
    });

    return _this;
  }

  _createClass(FieldWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _onClick = _this$props.onClick,
          isDisabled = _this$props.isDisabled,
          label = _this$props.label,
          isLabelHidden = _this$props.isLabelHidden,
          uniqueId = _this$props.uniqueId,
          error = _this$props.error,
          description = _this$props.description,
          hint = _this$props.hint,
          accessibilityDescribedBy = _this$props.accessibilityDescribedBy,
          renderBeforeContent = _this$props.renderBeforeContent,
          renderAfterContent = _this$props.renderAfterContent,
          renderConnectedBefore = _this$props.renderConnectedBefore,
          renderConnectedAfter = _this$props.renderConnectedAfter,
          children = _this$props.children,
          isBare = _this$props.isBare,
          size = _this$props.size,
          isRounded = _this$props.isRounded,
          isAdjustableHeight = _this$props.isAdjustableHeight,
          hasDefaultRenderContent = _this$props.hasDefaultRenderContent; // Figure out the correct thing to pass
      // to the field based on what is provided
      // errors trump explicit accessibilityDescribedBy,
      // which trump descriptions; accessibilityDescribedBy
      // will often be used to have an external description
      // (like a tooltip) and description is the internal
      // description

      var describedBy = undefined;

      if (error && typeof error === 'string') {
        describedBy = "".concat(uniqueId, "-error");
      } else if (typeof accessibilityDescribedBy !== 'undefined') {
        describedBy = accessibilityDescribedBy;
      } else if (description) {
        describedBy = "".concat(uniqueId, "-description");
      }

      return /*#__PURE__*/_react["default"].createElement(_styles.FieldRoot, {
        onClick: function onClick() {
          return _this2.handleClick(_onClick);
        }
      }, /*#__PURE__*/_react["default"].createElement(_designLanguage.StackChildren, {
        size: _designLanguage.StackChildren.Sizes.XxSmall
      }, label && !isLabelHidden && /*#__PURE__*/_react["default"].createElement(_designLanguage.InlineChildren, {
        alignItems: _designLanguage.InlineChildren.Alignment.FlexEnd,
        justifyContent: _designLanguage.InlineChildren.Justification.SpaceBetween,
        size: _designLanguage.InlineChildren.Sizes.Medium
      }, /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
        htmlFor: uniqueId,
        styles: _designLanguage.Text.Styles["".concat(_constants.SizeSemantics[size], "Label")],
        tag: "label",
        color: isDisabled ? _designLanguage.Text.Colors.TextDisabled : _designLanguage.Text.Colors.TextPrimary
      }, label), description && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
        id: "".concat(uniqueId, "-description"),
        styles: _designLanguage.Text.Styles["".concat(_constants.SizeSemantics[size], "Description")],
        color: isDisabled ? _designLanguage.Text.Colors.TextDisabled : _designLanguage.Text.Colors.TextSecondary
      }, description)), /*#__PURE__*/_react["default"].createElement(_InputWrapper["default"], {
        isDisabled: isDisabled,
        error: error,
        renderBeforeContent: renderBeforeContent,
        renderAfterContent: renderAfterContent,
        renderConnectedBefore: renderConnectedBefore,
        renderConnectedAfter: renderConnectedAfter,
        isBare: isBare,
        size: size,
        isRounded: isRounded,
        isAdjustableHeight: isAdjustableHeight,
        hasDefaultRenderContent: hasDefaultRenderContent
      }, /*#__PURE__*/_react["default"].cloneElement(_react["default"].Children.only(children), {
        id: uniqueId,
        'aria-describedby': describedBy,
        'aria-invalid': typeof error === 'boolean' && error === true ? true : undefined,
        // Pass an innerRef function to capture the
        // input element thats wrapped by Styled-Components
        // to allow us to focus into the element
        innerRef: function innerRef(node) {
          _this2.fieldContent = node;
        }
      })), error && error.length && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
        id: "".concat(uniqueId, "-error"),
        error: error,
        size: size
      }), hint && /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
        id: "".concat(uniqueId, "-hint"),
        styles: _designLanguage.Text.Styles["".concat(_constants.SizeSemantics[size], "Hint")],
        color: isDisabled ? _designLanguage.Text.Colors.TextDisabled : _designLanguage.Text.Colors.TextTertiary
      }, hint)));
    }
  }]);

  return FieldWrapper;
}(_react["default"].PureComponent);

var WrappedFieldWrapper = (0, _utilities.withUniqueId)(FieldWrapper, {
  prefix: PREFIX_ID
});
WrappedFieldWrapper.Sizes = _InputWrapper["default"].Sizes;
WrappedFieldWrapper.propTypes = _objectSpread(_objectSpread({}, _InputWrapper["default"].propTypes), {}, {
  label: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  hint: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  isLabelHidden: _propTypes["default"].bool,
  uniqueId: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  accessibilityDescribedBy: _propTypes["default"].string,
  hasDefaultRenderContent: _propTypes["default"].bool
});
WrappedFieldWrapper.defaultProps = {
  isLabelHidden: false,
  size: WrappedFieldWrapper.Sizes.Medium
};
var _default = WrappedFieldWrapper;
exports["default"] = _default;